import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { PASSWORD_REGEX } from '../constants';

export const getPasswordInputSchema = (t: TFunction) =>
  Yup.string()
    .required(t('core.required'))
    .matches(PASSWORD_REGEX, t('core.password.characters', { min: 14 }));
